import { createSelector } from "reselect";

import { getBillingDocuments } from "../root";
import { getInterestPreviewById } from "../interestPreview";
import { selectPaymentsByBillingDocumentIdLookup } from "../payments";
import {
  BusinessAggridDataPacket,
  selectBusinessesAggridDataById,
} from "./businesses";

export interface InterestPreviewAggridRow
  extends Partial<BusinessAggridDataPacket> {
  interestPreview: InterestPreviewData;
  billingDocument?: BillingDocument;
  payments: Payment[];
}

export const selectInterestPreviewAgGridData = createSelector(
  [
    getInterestPreviewById,
    getBillingDocuments,
    selectBusinessesAggridDataById,
    selectPaymentsByBillingDocumentIdLookup,
  ],
  (
    interestPreviewById,
    billingDocuments,
    businessesAggridDataById,
    paymentsByBillingDocumentIdLookup,
  ): InterestPreviewAggridRow[] =>
    Object.values(interestPreviewById).map(interestPreview => ({
      ...businessesAggridDataById[interestPreview.businessId],
      interestPreview,
      billingDocument: billingDocuments[interestPreview.billingDocumentId],
      payments:
        paymentsByBillingDocumentIdLookup[interestPreview.billingDocumentId] ??
        [],
    })),
);
